import SearchService from './Search.service'
export default SearchService
